import Vue from 'vue'
import { mapGetters } from 'vuex'

const User = {
    install (Vue) {
        Vue.mixin({
            computed: {
                ...mapGetters({
                    user: 'auth/user',
                })
            }
        })
    }
}

Vue.use(User)
